(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-lang"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__hwLangInit) return;
    window.__hwLangInit = true;
    document.addEventListener('click', (e) => {
      document.querySelectorAll('details[data-hw-lang][open]').forEach((d) => {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') document.querySelectorAll('details[data-hw-lang][open]').forEach((d) => d.removeAttribute('open'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hw-tokens"] && !Shopify.designMode) return;
  try {
    (() => {
    const reveal = (root) => {
      const targets = (root.querySelectorAll ? root : document).querySelectorAll('.hw-reveal:not([data-hw-observed])');
      if (!targets.length) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
      targets.forEach((el) => {
        el.setAttribute('data-hw-observed', '');
        io.observe(el);
      });
    };
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        reveal(document);
      });
    };
    const sweep = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      document.querySelectorAll('.hw-reveal:not(.is-visible)').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh * 0.95) el.classList.add('is-visible');
      });
    };
    let sweeping = false;
    const onScroll = () => {
      if (sweeping) return;
      sweeping = true;
      requestAnimationFrame(() => {
        sweeping = false;
        sweep();
      });
    };
    reveal(document);
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', () => setTimeout(sweep, 300));
    setTimeout(() => {
      document.querySelectorAll('.hw-reveal:not(.is-visible)').forEach((el) => el.classList.add('is-visible'));
    }, 4000);
    document.addEventListener('shopify:section:load', schedule);
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
